import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuditTrialDetails } from '../../../../shared/models/audits/audit-trial-details';

@Component({
  selector: 'app-user-profile-audit-modal',
  templateUrl: './user-profile-audit-modal.component.html',
  styleUrls: ['./user-profile-audit-modal.component.scss']
})
export class UserProfileAuditModalComponent {

@Input() isShowUserProfileAuditModal = false;
@Input() auditTrailData: AuditTrialDetails[] = [];
@Input() userName: string = '';

@Output() closeModal = new EventEmitter<boolean>();

closeUserProfileAuditModal(): void { 
  this.isShowUserProfileAuditModal = false;
  this.closeModal.emit(true);
}

}
